import { render, staticRenderFns } from "./NewAssignment.vue?vue&type=template&id=52f608b6&scoped=true&"
import script from "./NewAssignment.vue?vue&type=script&lang=js&"
export * from "./NewAssignment.vue?vue&type=script&lang=js&"
import style0 from "./NewAssignment.vue?vue&type=style&index=0&id=52f608b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f608b6",
  null
  
)

export default component.exports